import entities from "./entities/es";
import pages from "./pages/es";
import globals from "./globals/es";
import formValidation from "./formValidation/es";
import enums from "./enums/es";
export default { entities, pages, globals, formValidation, enums };
